import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import OrderStatusChip from 'components/OrderStatusChip';
import { cancellationReasons } from '@silvergatedelivery/constants';

const useStyles = makeStyles((theme) => ({
  orderCard: {
    marginBottom: theme.spacing(1),
    border: '1px solid #e0e0e0',
  },
  orderHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  orderDetails: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export default function OrderCard({ order, isSelected, onToggleSelection, cardSelectable = true }) {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={6} key={order.id}>
      <Card
        className={classes.orderCard}
        style={{
          borderColor: (order.status === 'cancelled' && !isSelected) || (order.status !== 'cancelled' && isSelected) ? '#1976d2' : undefined,
        }}
      >
        <CardContent>
          <div className={classes.orderHeader}>
            <Typography variant="subtitle1">
              {moment(order.date).format('MM/DD')} {order.mealSlot === 'lunch' ? '午餐' : '晚餐'}
            </Typography>
            <OrderStatusChip status={order.status} />
          </div>

          <div className={classes.orderDetails}>
            <div>
              <Typography variant="body2" color="textSecondary">
              餐廳：{order.restaurant?.name || '無'}
              </Typography>
              <Typography variant="body2" color="textSecondary">
              餐點：{order.mealItems?.map((item) => `${item.name} x${item.quantity}`).join(', ') || '無'}
              </Typography>
              {order.status === 'cancelled' && (
                <>
                  <Typography variant="body2" color="error">
                    取消原因：{cancellationReasons.find(({ value }) => order.cancellationReason === value)?.label || '無'}
                  </Typography>
                  {order.cancellationNote && (
                    <Typography variant="body2" color="error">
                      備註：{order.cancellationNote}
                    </Typography>
                  )}
                </>
              )}
            </div>

            {cardSelectable && (
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelected}
                      onChange={() => onToggleSelection(order.id)}
                      color="primary"
                    />
                  }
                  label="取消訂單"
                />
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
}

OrderCard.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    mealSlot: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    restaurant: PropTypes.shape({
      name: PropTypes.string,
    }),
    mealItems: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
    })),
    cancellationReason: PropTypes.string,
    cancellationNote: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggleSelection: PropTypes.func.isRequired,
  cardSelectable: PropTypes.bool,
};
